
// import React, { useState, useEffect, useRef } from 'react';
// import { FiFilter, FiRotateCw, FiPlus } from "react-icons/fi";
// import { DayPicker } from "react-day-picker";
// import "react-day-picker/dist/style.css";
// import { format } from "date-fns";
// import { FiSearch, FiChevronDown } from 'react-icons/fi';
// import check from "../../assets/check.svg";
// import { useNavigate } from 'react-router-dom';
// import map from '../../assets/map.svg'

// const dispatchData = [
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
//     { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
   
// ];

// const containerMovementData = [
//     { id: 'Customs_Form_342.pdf', movement: 'Bill of Lading', location: 'CONT-12988', date: 'Admin - [Name]', status: '10-Apr-2025 14:45 PM', eta: '10-Apr-2025 14:45 PM', delivered: '-' },
//     { id: 'Customs_Form_342.pdf', movement: 'Bill of Lading', location: 'CONT-12988', date: 'Admin - [Name]', status: '10-Apr-2025 14:45 PM', eta: '10-Apr-2025 14:45 PM', delivered: '-' },
// ];

// const subscriptionData = [
//     { id: 'Serial_No_Container_1.pdf', plan: 'Serial Number Document', startDate: 'CONT-12988', endDate: 'Driver - John Doe', status: '09-Apr-2025 11:30 AM' },
//     { id: 'Serial_No_Container_1.pdf', plan: 'Serial Number Document', startDate: 'CONT-12988', endDate: 'Driver - John Doe', status: '09-Apr-2025 11:30 AM' },
// ];

// const routeOptimizationData = [
//     { id: 'Super Admin', route: 'Full access to all modules, roles, settings, and document approval', distance: 'System', time: '01-Apr-2025' },
//     { id: 'Company Admin', route: 'Access to dashboard, profile mgmt, dispatch, reports, invoicing', distance: 'Super Admin', time: '03-Apr-2025'},
//     { id: 'Dispatcher', route: 'Assign containers, update trip status, manage POD & documents', distance: 'Super Admin', time: '03-Apr-2025'},
//     { id: 'Document Manager', route: 'Assign containers, update trip status, manage POD & documents', distance: 'Super Admin', time: '03-Apr-2025'},
//     { id: 'Driver', route: 'Upload documents, view assigned containers, update delivery status', distance: 'Super Admin', time: '03-Apr-2025'},
//     { id: 'Accountant', route: 'View invoices, generate reports, track payment status', distance: 'Super Admin', time: '03-Apr-2025'},
//     { id: 'Read-Only Viewer', route: 'View reports, documents, and trips without editing access', distance: 'Super Admin', time: '03-Apr-2025'},
// ];

// const statusColors = {
//     'In-Transit': 'bg-blue-500',
//     Delivered: 'bg-green-500',
//     Delayed: 'bg-red-500',
//     Pending: 'bg-yellow-400',
//     Completed: 'bg-green-500',
//     'In-Progress': 'bg-blue-500',
//     Active: 'bg-green-500',
//     Optimized: 'bg-green-500',
// };

// const drivers = [
//     { id: 1, name: 'John Doe', avatar: 'https://i.pravatar.cc/40?img=1' },
//     { id: 2, name: 'Jane Smith', avatar: 'https://i.pravatar.cc/40?img=2' },
//     { id: 3, name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/40?img=3' },
// ];

// const OrdersContainers = () => {
//     const [showCalendar, setShowCalendar] = useState(false);
//     const [selectedDates, setSelectedDates] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [showDropdown2, setShowDropdown2] = useState(false);
//     const [selectedRegions, setSelectedRegions] = useState([]);
//     const [selectedRegions1, setSelectedRegions1] = useState([]);
//     const dropdownRef = useRef(null);
//     const dropdownRef2 = useRef(null);
//     const calendarRef = useRef(null);
//     const buttonRef = useRef(null);
//     const buttonRef2 = useRef(null);
//     const buttonRef3 = useRef(null);
//     const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
//     const navigate = useNavigate();

//     const [selectedTab, setSelectedTab] = useState("Uploaded by Drivers"); // Default tab
//     const [showModal, setShowModal] = useState(false);
//     const [showModal2, setShowModal2] = useState(false);
//     const [search, setSearch] = useState('');
//     const [showDropdowns, setShowDropdowns] = useState(false);
//     const [selectedDriver, setSelectedDriver] = useState(null);

//     const filteredDrivers = drivers.filter(driver =>
//         driver.name.toLowerCase().includes(search.toLowerCase())
//     );

//     const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
//     const regions = [
//         "Africa", "UK", "America", "Caribbean",
//         "USA", "EU", "Canada", "Australia"
//     ];
//     const regions2 = [
//         "Delivered", "In-transit", "Delayed"
//     ];
//     const toggleLabels = ['Include Graphs', 'Charts', 'Driver', 'Route', 'Vehicle'];

//     // Create state for all toggles
//     const [toggles, setToggles] = useState({
//         'Include Graphs': true,
//         'Charts': true,
//         'Driver': true,
//         'Route': true,
//         'Vehicle': true,
//     });

//     const handleToggle = (label) => {
//         setToggles((prev) => ({
//             ...prev,
//             [label]: !prev[label],
//         }));
//     };
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (
//                 calendarRef.current &&
//                 !calendarRef.current.contains(event.target) &&
//                 !buttonRef.current.contains(event.target)
//             ) {
//                 setShowCalendar(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (
//                 dropdownRef.current &&
//                 !dropdownRef.current.contains(e.target) &&
//                 !buttonRef2.current.contains(e.target)
//             ) {
//                 setShowDropdown(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (
//                 dropdownRef2.current &&
//                 !dropdownRef2.current.contains(e.target) &&
//                 !buttonRef3.current.contains(e.target)
//             ) {
//                 setShowDropdown2(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     const handleCalendarToggle = () => {
//         if (buttonRef.current) {
//             const rect = buttonRef.current.getBoundingClientRect();
//             setCalendarPosition({
//                 top: rect.height + 5,
//                 left: 0,
//             });
//         }
//         setShowCalendar((prev) => !prev);
//     };

//     const toggleRegion = (region) => {
//         setSelectedRegions(prev =>
//             prev.includes(region)
//                 ? prev.filter(r => r !== region)
//                 : [...prev, region]
//         );
//     };

//     const toggleRegion2 = (region1) => {
//         setSelectedRegions1(prev =>
//             prev.includes(region1)
//                 ? prev.filter(r => r !== region1)
//                 : [...prev, region1]
//         );
//     };

//     const openSuccessModal = () => {
//         setShowModal(false);
//         setIsSuccessModalOpen(true);
//     };

//     return (
//         <div className="text-white relative">
//             <div className="flex items-center justify-between mb-6">
//                 <h1 className="text-2xl font-semibold">Document Management</h1>
//             </div>

//             <div className="mb-6">
//                 <div className="flex gap-4 bg-white pe-2 ps-2 pt-1 pb-1 border rounded-xl">
//                     <button
//                         onClick={() => setSelectedTab("Uploaded by Drivers")}
//                         className={`px-4 py-2 rounded-lg font-medium ${selectedTab === "Uploaded by Drivers"
//                             ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
//                             : "bg-white text-[#7E31FF]"
//                             }`}
//                     >
//                     Uploaded by Drivers
//                     </button>
//                     <button
//                         onClick={() => setSelectedTab("Uploaded by Admin")}
//                         className={`px-4 py-2 rounded-lg font-medium ${selectedTab === "Uploaded by Admin"
//                             ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
//                             : "bg-white text-[#7E31FF]"
//                             }`}
//                     >
//                         Uploaded by Admin
//                     </button>
//                     <button
//                         onClick={() => setSelectedTab("Pending Verification")}
//                         className={`px-4 py-2 rounded-lg font-medium ${selectedTab === "Pending Verification"
//                             ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
//                             : "bg-white text-[#7E31FF]"
//                             }`}
//                     >
//                     Pending Verification
//                     </button>
//                     <button
//                         onClick={() => setSelectedTab("Access Roles")}
//                         className={`px-4 py-2 rounded-lg font-medium ${selectedTab === "Access Roles"
//                             ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
//                             : "bg-white text-[#7E31FF]"
//                             }`}
//                     >
//                         Access Roles
//                     </button>
//                 </div>
//             </div>

//             <div className="flex items-center justify-between mb-6">
//                 <div className="relative flex items-center bg-[#10194E] rounded-xl shadow-md">
//                     <div className="flex items-center gap-2 px-4 py-5 border-r border-[#1E2A60] text-white">
//                         <FiFilter className="text-lg" />
//                         <span className="text-sm">Filter By</span>
//                     </div>

//                     <div className="relative">
//                         <button
//                             ref={buttonRef}
//                             onClick={handleCalendarToggle}
//                             className="px-4 py-5 text-sm text-white border-r border-[#1E2A60] bg-transparent"
//                         >
//                             {selectedDates.length > 0
//                                 ? selectedDates.map((date) => format(date, "PP")).join(", ")
//                                 : "Date"}
//                         </button>
//                         {showCalendar && (
//                             <div
//                                 ref={calendarRef}
//                                 className="absolute left-9 -translate-x-24 p-4 shadow-lg rounded z-50"
//                                 style={{
//                                     background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
//                                     top: calendarPosition.top,
//                                     left: calendarPosition.left,
//                                 }}
//                             >
//                                 <DayPicker
//                                     mode="multiple"
//                                     selected={selectedDates}
//                                     onSelect={setSelectedDates}
//                                     footer={
//                                         <div className="pt-4">
//                                             <div className="flex justify-start">
//                                                 <span className="text-sm text-gray-400">You can choose multiple dates</span>
//                                             </div>
//                                             <div className="flex justify-center mt-2">
//                                                 <button
//                                                     onClick={() => setShowCalendar(false)}
//                                                     className="bg-[#6F1AFF] text-white px-4 py-1 rounded"
//                                                 >
//                                                     Apply
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     }
//                                 />
//                             </div>
//                         )}
//                     </div>

//                     <div className="relative">
//                         <button
//                             ref={buttonRef2}
//                             onClick={() => setShowDropdown(!showDropdown)}
//                             className="bg-transparent text-white px-4 py-5 text-sm border-r border-[#1E2A60] outline-none"
//                         >
//                             Location
//                         </button>
//                         {showDropdown && (
//                             <div
//                                 ref={dropdownRef}
//                                 style={{
//                                     background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
//                                 }}
//                                 className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-96 text-white rounded-2xl p-6 z-50 shadow-lg"
//                             >
//                                 <h2 className="text-lg font-semibold mb-4">User Location</h2>
//                                 <div className="grid grid-cols-3 gap-3 mb-4">
//                                     {regions.map((region) => (
//                                         <button
//                                             key={region}
//                                             onClick={() => toggleRegion(region)}
//                                             className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions.includes(region)
//                                                 ? "bg-white text-black font-semibold"
//                                                 : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
//                                                 }`}
//                                         >
//                                             {region}
//                                         </button>
//                                     ))}
//                                 </div>
//                                 <p className="text-sm text-gray-300 mb-3">*You can choose multiple Locations</p>
//                                 <div className="text-center">
//                                     <button
//                                         onClick={() => setShowDropdown(false)}
//                                         className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
//                                     >
//                                         Apply Now
//                                     </button>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     <div className="relative">
//                         <button
//                             ref={buttonRef3}
//                             onClick={() => setShowDropdown2(!showDropdown2)}
//                             className="bg-transparent text-white px-4 py-5 text-sm border-r border-[#1E2A60] outline-none"
//                         >
//                             Status
//                         </button>
//                         {showDropdown2 && (
//                             <div
//                                 ref={dropdownRef2}
//                                 style={{
//                                     background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
//                                 }}
//                                 className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-96 text-white rounded-2xl p-6 z-50 shadow-lg"
//                             >
//                                 <h2 className="text-lg font-semibold mb-4">Select Order Status</h2>
//                                 <div className="grid grid-cols-3 gap-3 mb-4">
//                                     {regions2.map((region1) => (
//                                         <button
//                                             key={region1}
//                                             onClick={() => toggleRegion2(region1)}
//                                             className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions1.includes(region1)
//                                                 ? "bg-white text-black font-semibold"
//                                                 : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
//                                                 }`}
//                                         >
//                                             {region1}
//                                         </button>
//                                     ))}
//                                 </div>
//                                 <p className="text-sm text-gray-300 mb-3">*You can choose multiple Order Status</p>
//                                 <div className="text-center">
//                                     <button
//                                         onClick={() => setShowDropdown2(false)}
//                                         className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
//                                     >
//                                         Apply Now
//                                     </button>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     <button className="flex items-center gap-1 px-4 py-5 text-sm text-orange-400 hover:underline">
//                         <FiRotateCw className="text-sm" />
//                         Reset Filter
//                     </button>
//                 </div>

//                 {/* <button
//                     onClick={() => setShowModal(true)}
//                     className="ml-4 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] hover:opacity-90 px-5 py-2 rounded-xl text-white font-medium flex items-center gap-2 shadow-md"
//                 >
//                     <FiPlus className="text-md" />
//                     Custom Report Generator
//                 </button> */}

//                 {showModal && (
//                     <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
//                         <div
//                             className="rounded-xl shadow-xl text-white p-6 relative w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
//                             style={{
//                                 background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
//                             }}
//                         >
//                             <button
//                                 onClick={() => setShowModal(false)}
//                                 className="absolute top-2 right-4 text-2xl font-bold"
//                             >
//                                 ×
//                             </button>

//                             <h2 className="text-xl font-bold mb-4">Custom Report Generator</h2>

                           

//                             <form className="space-y-4">



//                                 <div>
//                                     <label className="text-sm block mb-1">Report Type</label>
//                                     <select className="w-full px-3 py-2 rounded bg-white text-black">
//                                         <option>Select Report Type</option>
//                                         <option>Dispatch Summary</option>
//                                         <option>Container Tracking Logs</option>
//                                         <option>Driver-wise Performance</option>
//                                         <option>Fuel Usage Summary</option>
//                                         <option>Maintenance Logs</option>
//                                         <option>Custom Time Report</option>
//                                     </select>
//                                 </div>
//                                 <div>
//                                     <label className="text-sm block mb-1">From Date</label>
//                                     <input
//                                         className="w-full px-3 py-2 rounded bg-white text-black"
//                                         placeholder="April 10, 2025"
//                                     />
//                                 </div>
//                                 <div>
//                                     <label className="text-sm block mb-1">To Date</label>
//                                     <input
//                                         className="w-full px-3 py-2 rounded bg-white text-black"
//                                         placeholder="April 10, 2025"
//                                     />
//                                 </div>
//                                 <div className="grid grid-cols-3 gap-4 mt-4 max-w-md">
//                                     {toggleLabels.map((label, index) => (
//                                         <div
//                                             key={index}
//                                             className="flex items-center bg-white px-4 py-2 rounded shadow-md"
//                                         >
//                                             <button
//                                                 onClick={() => handleToggle(label)}
//                                                 className={`relative w-10 h-5 flex items-center rounded-full transition-colors duration-300 ${toggles[label] ? 'bg-green-500' : 'bg-gray-300'
//                                                     }`}
//                                             >
//                                                 <span
//                                                     className={`absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300 ${toggles[label] ? 'translate-x-5' : ''
//                                                         }`}
//                                                 ></span>
//                                             </button>
//                                             <span className="ml-3 text-sm text-black">{label}</span>
//                                         </div>
//                                     ))}
//                                 </div>

//                             </form>
//                             <button
//                                 type="submit"
//                                                                 onClick={() => setShowModal(false)}

//                                 className="mt-6 w-full bg-[#792aff] text-white py-2 rounded-md font-semibold"
//                             >
//                                 Generate Report
//                             </button>
//                         </div>
//                     </div>
//                 )}

//                 {isSuccessModalOpen && (
//                     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//                         <div className="bg-[#0F0D2E] p-8 rounded-2xl w-full max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
//                             <h2 style={{ fontFamily: "Poppins" }} className="text-[30px] font-bold text-white leading-tight">
//                                 Assigned <span className="text-[45px] text-[#6F1AFF]">Successfully</span>
//                             </h2>
//                             <p className="text-sm text-gray-400 mb-6 mt-1">
//                                 Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.
//                             </p>
//                             <div className="flex justify-center mb-6">
//                                 <img src={check} alt="Checkmark" className="w-[197px] h-[156px]" />
//                             </div>
//                             <button
//                                 onClick={(e) => {
//                                     e.preventDefault();
//                                     setIsSuccessModalOpen(false);
//                                 }}
//                                 className="w-full py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium"
//                             >
//                                 OK
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* Tab Content */}
//             <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
//                 {selectedTab === "Uploaded by Drivers" && (
//                     <table className="w-full table-auto text-sm text-left">
//                         <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
//                             <tr>
//                                 <th className="p-4">
//                                     <input type="checkbox" />
//                                 </th>
//                                 <th className="p-4">Document title</th>
//                                 <th className="p-4">Type</th>
//                                 <th className="p-4">Container No</th>
//                                 <th className="p-4">Uploaded by</th>
//                                 <th className="p-4">Uploaded date & time</th>
//                                 <th className="p-4">View</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {dispatchData.map((row, idx) => (
//                                 <tr key={idx} className="border-t border-[#2A2A4D]">
//                                     <td className="p-4">
//                                         <input type="checkbox" />
//                                     </td>
//                                     <td className="p-4">{row.id}</td>
//                                     <td className="p-4">{row.order}</td>
                            
//                                     <td className="p-4">{row.origin}</td>

//                                     <td className="p-4">{row.destination}</td>
//                                     <td className="p-4">

// {row.type}

// </td>

//                                     <td className="p-4">
//                                         <button
//                                             className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
//                                         >
//                                             View
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}

//                 {selectedTab === "Uploaded by Admin" && (
//                     <table className="w-full table-auto text-sm text-left">
//                         <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
//                             <tr>
//                                 <th className="p-4">
//                                     <input type="checkbox" />
//                                 </th>
//                                 <th className="p-4">Document title</th>
//                                 <th className="p-4">Type</th>
//                                 <th className="p-4">Container No.</th>
//                                 <th className="p-4">Uploaded By</th>
//                                 <th className="p-4">Upload Date & Time</th>
//                                 <th className="p-4">View</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {containerMovementData.map((row, idx) => (
//                                 <tr key={idx} className="border-t border-[#2A2A4D]">
//                                     <td className="p-4">
//                                         <input type="checkbox" />
//                                     </td>
//                                     <td className="p-4">{row.id}</td>
//                                     <td className="p-4">{row.movement}</td>
//                                     <td className="p-4">{row.location}</td>
//                                     <td className="p-4">{row.date}</td>
                    
//                                     <td className="p-4">

//                                         {row.eta}
//                                     </td>
                    
//                                     <td className="p-4">
//                                         <button

//                                             className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
//                                         >
//                                             View
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}

//                 {selectedTab === "Pending Verification" && (
//                     <table className="w-full table-auto text-sm text-left">
//                         <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
//                             <tr>
//                                 <th className="p-4">
//                                     <input type="checkbox" />
//                                 </th>
//                                 <th className="p-4">Document title</th>
//                                 <th className="p-4">Type</th>
//                                 <th className="p-4">Container No</th>
//                                 <th className="p-4">Uploaded by</th>
//                                 <th className="p-4">Uploaded date & time </th>
//                                 <th className="p-4">Download </th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {subscriptionData.map((row, idx) => (
//                                 <tr key={idx} className="border-t border-[#2A2A4D]">
//                                     <td className="p-4">
//                                         <input type="checkbox" />
//                                     </td>
//                                     <td className="p-4">{row.id}</td>
//                                     <td className="p-4">{row.plan}</td>
//                                     <td className="p-4">{row.startDate}</td>
//                                     <td className="p-4">{row.endDate}</td>
//                                     <td className="p-4">

//                                         {row.status}

//                                     </td>
//                                     <td className="p-4">
//                                         <button
//                                             className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
//                                         >
//                                             Download
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}

//                 {selectedTab === "Access Roles" && (
//                     <table className="w-full table-auto text-sm text-left">
//                         <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
//                             <tr>
//                                 <th className="p-4">
//                                     <input type="checkbox" />
//                                 </th>
//                                 <th className="p-4">Role name</th>
//                                 <th className="p-4">Permissions summary</th>
//                                 <th className="p-4">Created by</th>
//                                 <th className="p-4">Created date</th>
//                                 <th className="p-4">DOWNLOAD</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {routeOptimizationData.map((row, idx) => (
//                                 <tr key={idx} className="border-t border-[#2A2A4D]">
//                                     <td className="p-4">
//                                         <input type="checkbox" />
//                                     </td>
//                                     <td className="p-4">{row.id}</td>
//                                     <td className="p-4">{row.route}</td>
//                                     <td className="p-4">{row.distance}</td>
//                                     <td className="p-4">{row.time}</td>
//                                     <td className="p-4">
//                                         <button
//                                             className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
//                                         >
//                                             Download
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}

//                 <div className="text-sm text-gray-400 p-4">
//                     Showing 1-{selectedTab === "Dispatch Reports" ? "09" : selectedTab === "Container Movement History" ? "02" : selectedTab === "Subscription Reports" ? "02" : "02"} of {selectedTab === "Dispatch Reports" ? "09" : selectedTab === "Container Movement History" ? "02" : selectedTab === "Subscription Reports" ? "02" : "02"}
//                 </div>
//             </div>

//             {showModal2 && (
//                 <div className="fixed inset-0 bg-opacity-50 z-50 flex items-center justify-center">
//                     <div
//                         className="rounded-xl shadow-xl text-white p-6 relative w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
//                         style={{
//                             background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
//                         }}
//                     >
//                         <button
//                             onClick={() => setShowModal2(false)}
//                             className="absolute top-2 right-4 text-2xl font-bold"
//                         >
//                             ×
//                         </button>

//                         <h2 className="text-xl font-bold mb-4">Detailed Container View</h2>

//                         <form className="space-y-4">
//                             <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                                 Shipment Overview
//                             </h3>
//                             <div>
//                                 <label className="text-sm block mb-1">Container ID</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Auto-generate"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Purchase Order No.</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="PO#00981"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Customer Name</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="JetLogistics Pvt. Ltd."
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Number of Pallets</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="22"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Goods Type</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Electronics"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Added on</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="April 10, 2025"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Estimated Delivery Date</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="April 15, 2025"
//                                 />
//                             </div>
//                             <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                                 Route & Status Tracking
//                             </h3>
//                             <div>
//                                 <label className="text-sm block mb-1">Route</label>
//                                 <div className="relative w-full rounded-lg overflow-hidden shadow-md">
//                                     <img
//                                         src={map}
//                                         alt="Map"
//                                         className="w-full h-auto w-full px-3 py-2 rounded bg-white text-black"
//                                     />
//                                     <button className="absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-violet-600 text-white px-6 py-2 rounded-md shadow-lg hover:bg-violet-700 flex items-center gap-2">
//                                         <span role="img" aria-label="truck">🚛</span> Track Container
//                                     </button>
//                                 </div>
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Current Status</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     placeholder="In Transit"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Stops List</label>
//                                 <textarea
//                                     rows="3"
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Multi-stop breakdown with timestamps (e.g., warehouse hubs)"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">ETA</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Auto Calculated"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Status Updates</label>
//                                 <textarea
//                                     rows="3"
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="[10 Apr - 9:00 AM] - Picked up from Delhi Hub"
//                                 />
//                             </div>

//                             <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                                 Driver Assignment & Control
//                             </h3>
//                             <div>
//                                 <label className="text-sm block mb-1">Assigned Driver</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     placeholder="John Michael #D812"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Vehicle Number</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     placeholder="UP14 BK 7821"
//                                 />
//                             </div>
//                             <div className="mb-4">
//                                 <label className="text-sm block mb-2 text-white">Driver Contact</label>
//                                 <div className="flex gap-4">
//                                     <button className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium">
//                                         <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a2 2 0 011.95 1.45l.71 2.55a2 2 0 01-.45 1.9l-1.3 1.3a11.042 11.042 0 005.06 5.06l1.3-1.3a2 2 0 011.9-.45l2.55.71A2 2 0 0121 17.72V21a2 2 0 01-2 2h-1C9.16 23 1 14.84 1 4V3a2 2 0 012-2h0z" />
//                                         </svg>
//                                         Call
//                                     </button>
//                                     <button className="flex items-center gap-2 bg-[#F1EEFF] text-[#8000FF] px-4 py-2 rounded-md font-medium">
//                                         <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h6m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
//                                         </svg>
//                                         Message
//                                     </button>
//                                 </div>
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Current Location</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Map ping from real-time GPS"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Goods type</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Electronics"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Route Notes</label>
//                                 <textarea
//                                     rows="3"
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Avoid Mumbai route due to traffic"
//                                 />
//                             </div>
//                             <h3 className="text-sm text-cyan-400 font-semibold mt-4">
//                                 Driver Assignment
//                             </h3>
//                             <div>
//                                 <label className="text-sm block mb-1">Vehicle Number</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     placeholder="Auto-filled Based on selected driver"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Driver Contact</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Auto-filledFrom driver profile"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Current Location</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Map ping from real-time GPS"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Goods Type</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="Electronics"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Added on</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="April 10, 2025"
//                                 />
//                             </div>
//                             <div>
//                                 <label className="text-sm block mb-1">Estimated Delivery Date</label>
//                                 <input
//                                     className="w-full px-3 py-2 rounded bg-white text-black"
//                                     defaultValue="April 15, 2025"
//                                 />
//                             </div>
//                         </form>

//                         <div className="mt-6 flex gap-4 justify-center">
//                             <button
//                                 onClick={(e) => {
//                                     e.preventDefault();
//                                     setShowModal2(false);
//                                 }}
//                                 className="flex items-center gap-2 bg-[#6f1aff] text-white py-2 px-4 rounded-md font-semibold"
//                             >
//                                 <span className="text-green-400">✅</span> Mark as Delivered
//                             </button>
//                             <button
//                                 onClick={(e) => {
//                                     e.preventDefault();
//                                     setShowModal2(false);
//                                 }}
//                                 className="bg-[#00B69B] text-white py-2 px-4 rounded-md font-semibold"
//                             >
//                                 Save & Update
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default OrdersContainers;
import React, { useState, useEffect, useRef } from 'react';
import { FiFilter, FiRotateCw, FiPlus } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { FiSearch, FiChevronDown } from 'react-icons/fi';
import check from "../../assets/check.svg";
import { useNavigate } from 'react-router-dom';
import map from '../../assets/map.svg'

const dispatchData = [
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
    { id: 'cont_12988_serial.jpg', order: 'Container Serial Numbers', origin: 'CONT-12988', destination: 'Driver - A. Patel', type: 'Apr 09, 12:30 PM' },
];

const containerMovementData = [
    { id: 'Customs_Form_342.pdf', movement: 'Bill of Lading', location: 'CONT-12988', date: 'Admin - [Name]', status: '10-Apr-2025 14:45 PM', eta: '10-Apr-2025 14:45 PM', delivered: '-' },
    { id: 'Customs_Form_342.pdf', movement: 'Bill of Lading', location: 'CONT-12988', date: 'Admin - [Name]', status: '10-Apr-2025 14:45 PM', eta: '10-Apr-2025 14:45 PM', delivered: '-' },
];

const subscriptionData = [
    { id: 'Serial_No_Container_1.pdf', plan: 'Serial Number Document', startDate: 'CONT-12988', endDate: 'Driver - John Doe', status: '09-Apr-2025 11:30 AM' },
    { id: 'Serial_No_Container_1.pdf', plan: 'Serial Number Document', startDate: 'CONT-12988', endDate: 'Driver - John Doe', status: '09-Apr-2025 11:30 AM' },
];

const routeOptimizationData = [
    { id: 'Super Admin', route: 'Full access to all modules, roles, settings, and document approval', distance: 'System', time: '01-Apr-2025' },
    { id: 'Company Admin', route: 'Access to dashboard, profile mgmt, dispatch, reports, invoicing', distance: 'Super Admin', time: '03-Apr-2025'},
    { id: 'Dispatcher', route: 'Assign containers, update trip status, manage POD & documents', distance: 'Super Admin', time: '03-Apr-2025'},
    { id: 'Document Manager', route: 'Assign containers, update trip status, manage POD & documents', distance: 'Super Admin', time: '03-Apr-2025'},
    { id: 'Driver', route: 'Upload documents, view assigned containers, update delivery status', distance: 'Super Admin', time: '03-Apr-2025'},
    { id: 'Accountant', route: 'View invoices, generate reports, track payment status', distance: 'Super Admin', time: '03-Apr-2025'},
    { id: 'Read-Only Viewer', route: 'View reports, documents, and trips without editing access', distance: 'Super Admin', time: '03-Apr-2025'},
];

const statusColors = {
    'In-Transit': 'bg-blue-500',
    Delivered: 'bg-green-500',
    Delayed: 'bg-red-500',
    Pending: 'bg-yellow-400',
    Completed: 'bg-green-500',
    'In-Progress': 'bg-blue-500',
    Active: 'bg-green-500',
    Optimized: 'bg-green-500',
};

const drivers = [
    { id: 1, name: 'John Doe', avatar: 'https://i.pravatar.cc/40?img=1' },
    { id: 2, name: 'Jane Smith', avatar: 'https://i.pravatar.cc/40?img=2' },
    { id: 3, name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/40?img=3' },
];

const OrdersContainers = () => {
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedRegions1, setSelectedRegions1] = useState([]);
    const dropdownRef = useRef(null);
    const dropdownRef2 = useRef(null);
    const calendarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonRef2 = useRef(null);
    const buttonRef3 = useRef(null);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const navigate = useNavigate();

    const [selectedTab, setSelectedTab] = useState("Uploaded by Drivers"); // Default tab
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [search, setSearch] = useState('');
    const [showDropdowns, setShowDropdowns] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

    const filteredDrivers = drivers.filter(driver =>
        driver.name.toLowerCase().includes(search.toLowerCase())
    );

    const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
    const regions = [
        "Africa", "UK", "America", "Caribbean",
        "USA", "EU", "Canada", "Australia"
    ];
    const regions2 = [
        "Delivered", "In-transit", "Delayed"
    ];
    const toggleLabels = ['Include Graphs', 'Charts', 'Driver', 'Route', 'Vehicle'];

    // Create state for all toggles
    const [toggles, setToggles] = useState({
        'Include Graphs': true,
        'Charts': true,
        'Driver': true,
        'Route': true,
        'Vehicle': true,
    });

    const handleToggle = (label) => {
        setToggles((prev) => ({
            ...prev,
            [label]: !prev[label],
        }));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowCalendar(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target) &&
                !buttonRef2.current.contains(e.target)
            ) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef2.current &&
                !dropdownRef2.current.contains(e.target) &&
                !buttonRef3.current.contains(e.target)
            ) {
                setShowDropdown2(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleCalendarToggle = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCalendarPosition({
                top: rect.height + 5,
                left: 0,
            });
        }
        setShowCalendar((prev) => !prev);
    };

    const toggleRegion = (region) => {
        setSelectedRegions(prev =>
            prev.includes(region)
                ? prev.filter(r => r !== region)
                : [...prev, region]
        );
    };

    const toggleRegion2 = (region1) => {
        setSelectedRegions1(prev =>
            prev.includes(region1)
                ? prev.filter(r => r !== region1)
                : [...prev, region1]
        );
    };

    const openSuccessModal = () => {
        setShowModal(false);
        setIsSuccessModalOpen(true);
    };

    // Check if mobile view
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="text-white relative px-2 md:px-0">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
                <h1 className="text-2xl font-semibold">Document Management</h1>
            </div>

            {/* Tab Navigation */}
            <div className="mb-6">
                <div className="flex flex-col md:flex-row gap-1 md:gap-4 bg-white p-1 md:pe-2 md:ps-2 md:pt-1 md:pb-1 border rounded-xl overflow-x-auto">
                    <div className="flex md:flex-row gap-1 md:gap-4 min-w-max">
                        <button
                            onClick={() => setSelectedTab("Uploaded by Drivers")}
                            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Uploaded by Drivers"
                                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                                : "bg-white text-[#7E31FF]"
                                }`}
                        >
                            Uploaded by Drivers
                        </button>
                        <button
                            onClick={() => setSelectedTab("Uploaded by Admin")}
                            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Uploaded by Admin"
                                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                                : "bg-white text-[#7E31FF]"
                                }`}
                        >
                            Uploaded by Admin
                        </button>
                        <button
                            onClick={() => setSelectedTab("Pending Verification")}
                            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Pending Verification"
                                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                                : "bg-white text-[#7E31FF]"
                                }`}
                        >
                            Pending Verification
                        </button>
                        <button
                            onClick={() => setSelectedTab("Access Roles")}
                            className={`px-4 py-2 rounded-lg font-medium text-sm md:text-base ${selectedTab === "Access Roles"
                                ? "bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white"
                                : "bg-white text-[#7E31FF]"
                                }`}
                        >
                            Access Roles
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
                {isMobile ? (
                    <div className="w-full">
                        <button
                            onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)}
                            className="w-full flex items-center justify-between bg-[#10194E] rounded-xl shadow-md p-4"
                        >
                            <div className="flex items-center gap-2 text-white">
                                <FiFilter className="text-lg" />
                                <span className="text-sm">Filter By</span>
                            </div>
                            <FiChevronDown className={`text-white transition-transform ${isMobileFilterOpen ? 'rotate-180' : ''}`} />
                        </button>
                        
                        {isMobileFilterOpen && (
                            <div className="mt-2 bg-[#10194E] rounded-xl p-4 space-y-4">
                                <div className="relative">
                                    <button
                                        ref={buttonRef}
                                        onClick={handleCalendarToggle}
                                        className="w-full px-4 py-3 text-sm text-white border border-[#1E2A60] bg-transparent rounded-lg flex justify-between items-center"
                                    >
                                        <span>
                                            {selectedDates.length > 0
                                                ? selectedDates.map((date) => format(date, "PP")).join(", ")
                                                : "Date"}
                                        </span>
                                        <FiChevronDown />
                                    </button>
                                    {showCalendar && (
                                        <div
                                            ref={calendarRef}
                                            className="absolute left-0 right-0 mt-1 p-4 shadow-lg rounded z-50"
                                            style={{
                                                background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                            }}
                                        >
                                            <DayPicker
                                                mode="multiple"
                                                selected={selectedDates}
                                                onSelect={setSelectedDates}
                                                footer={
                                                    <div className="pt-4">
                                                        <div className="flex justify-start">
                                                            <span className="text-sm text-gray-400">You can choose multiple dates</span>
                                                        </div>
                                                        <div className="flex justify-center mt-2">
                                                            <button
                                                                onClick={() => setShowCalendar(false)}
                                                                className="bg-[#6F1AFF] text-white px-4 py-1 rounded"
                                                            >
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="relative">
                                    <button
                                        ref={buttonRef2}
                                        onClick={() => setShowDropdown(!showDropdown)}
                                        className="w-full bg-transparent text-white px-4 py-3 text-sm border border-[#1E2A60] outline-none rounded-lg flex justify-between items-center"
                                    >
                                        <span>Location</span>
                                        <FiChevronDown />
                                    </button>
                                    {showDropdown && (
                                        <div
                                            ref={dropdownRef}
                                            style={{
                                                background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                            }}
                                            className="absolute left-0 right-0 mt-1 w-full text-white rounded-2xl p-4 z-50 shadow-lg"
                                        >
                                            <h2 className="text-lg font-semibold mb-4">User Location</h2>
                                            <div className="grid grid-cols-2 gap-3 mb-4">
                                                {regions.map((region) => (
                                                    <button
                                                        key={region}
                                                        onClick={() => toggleRegion(region)}
                                                        className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions.includes(region)
                                                            ? "bg-white text-black font-semibold"
                                                            : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                            }`}
                                                    >
                                                        {region}
                                                    </button>
                                                ))}
                                            </div>
                                            <p className="text-sm text-gray-300 mb-3">*You can choose multiple Locations</p>
                                            <div className="text-center">
                                                <button
                                                    onClick={() => setShowDropdown(false)}
                                                    className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
                                                >
                                                    Apply Now
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="relative">
                                    <button
                                        ref={buttonRef3}
                                        onClick={() => setShowDropdown2(!showDropdown2)}
                                        className="w-full bg-transparent text-white px-4 py-3 text-sm border border-[#1E2A60] outline-none rounded-lg flex justify-between items-center"
                                    >
                                        <span>Status</span>
                                        <FiChevronDown />
                                    </button>
                                    {showDropdown2 && (
                                        <div
                                            ref={dropdownRef2}
                                            style={{
                                                background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                            }}
                                            className="absolute left-0 right-0 mt-1 w-full text-white rounded-2xl p-4 z-50 shadow-lg"
                                        >
                                            <h2 className="text-lg font-semibold mb-4">Select Order Status</h2>
                                            <div className="grid grid-cols-2 gap-3 mb-4">
                                                {regions2.map((region1) => (
                                                    <button
                                                        key={region1}
                                                        onClick={() => toggleRegion2(region1)}
                                                        className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions1.includes(region1)
                                                            ? "bg-white text-black font-semibold"
                                                            : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                            }`}
                                                    >
                                                        {region1}
                                                    </button>
                                                ))}
                                            </div>
                                            <p className="text-sm text-gray-300 mb-3">*You can choose multiple Order Status</p>
                                            <div className="text-center">
                                                <button
                                                    onClick={() => setShowDropdown2(false)}
                                                    className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
                                                >
                                                    Apply Now
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <button className="w-full flex items-center justify-center gap-1 px-4 py-3 text-sm text-orange-400 hover:underline border border-[#1E2A60] rounded-lg">
                                    <FiRotateCw className="text-sm" />
                                    Reset Filter
                                </button>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="relative flex items-center bg-[#10194E] rounded-xl shadow-md">
                        <div className="flex items-center gap-2 px-4 py-5 border-r border-[#1E2A60] text-white">
                            <FiFilter className="text-lg" />
                            <span className="text-sm">Filter By</span>
                        </div>

                        <div className="relative">
                            <button
                                ref={buttonRef}
                                onClick={handleCalendarToggle}
                                className="px-4 py-5 text-sm text-white border-r border-[#1E2A60] bg-transparent"
                            >
                                {selectedDates.length > 0
                                    ? selectedDates.map((date) => format(date, "PP")).join(", ")
                                    : "Date"}
                            </button>
                            {showCalendar && (
                                <div
                                    ref={calendarRef}
                                    className="absolute left-9 -translate-x-24 p-4 shadow-lg rounded z-50"
                                    style={{
                                        background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                        top: calendarPosition.top,
                                        left: calendarPosition.left,
                                    }}
                                >
                                    <DayPicker
                                        mode="multiple"
                                        selected={selectedDates}
                                        onSelect={setSelectedDates}
                                        footer={
                                            <div className="pt-4">
                                                <div className="flex justify-start">
                                                    <span className="text-sm text-gray-400">You can choose multiple dates</span>
                                                </div>
                                                <div className="flex justify-center mt-2">
                                                    <button
                                                        onClick={() => setShowCalendar(false)}
                                                        className="bg-[#6F1AFF] text-white px-4 py-1 rounded"
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    />
                                </div>
                            )}
                        </div>

                        <div className="relative">
                            <button
                                ref={buttonRef2}
                                onClick={() => setShowDropdown(!showDropdown)}
                                className="bg-transparent text-white px-4 py-5 text-sm border-r border-[#1E2A60] outline-none"
                            >
                                Location
                            </button>
                            {showDropdown && (
                                <div
                                    ref={dropdownRef}
                                    style={{
                                        background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                    }}
                                    className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-96 text-white rounded-2xl p-6 z-50 shadow-lg"
                                >
                                    <h2 className="text-lg font-semibold mb-4">User Location</h2>
                                    <div className="grid grid-cols-3 gap-3 mb-4">
                                        {regions.map((region) => (
                                            <button
                                                key={region}
                                                onClick={() => toggleRegion(region)}
                                                className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions.includes(region)
                                                    ? "bg-white text-black font-semibold"
                                                    : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                    }`}
                                            >
                                                {region}
                                            </button>
                                        ))}
                                    </div>
                                    <p className="text-sm text-gray-300 mb-3">*You can choose multiple Locations</p>
                                    <div className="text-center">
                                        <button
                                            onClick={() => setShowDropdown(false)}
                                            className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
                                        >
                                            Apply Now
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="relative">
                            <button
                                ref={buttonRef3}
                                onClick={() => setShowDropdown2(!showDropdown2)}
                                className="bg-transparent text-white px-4 py-5 text-sm border-r border-[#1E2A60] outline-none"
                            >
                                Status
                            </button>
                            {showDropdown2 && (
                                <div
                                    ref={dropdownRef2}
                                    style={{
                                        background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                    }}
                                    className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-96 text-white rounded-2xl p-6 z-50 shadow-lg"
                                >
                                    <h2 className="text-lg font-semibold mb-4">Select Order Status</h2>
                                    <div className="grid grid-cols-3 gap-3 mb-4">
                                        {regions2.map((region1) => (
                                            <button
                                                key={region1}
                                                onClick={() => toggleRegion2(region1)}
                                                className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions1.includes(region1)
                                                    ? "bg-white text-black font-semibold"
                                                    : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                    }`}
                                            >
                                                {region1}
                                            </button>
                                        ))}
                                    </div>
                                    <p className="text-sm text-gray-300 mb-3">*You can choose multiple Order Status</p>
                                    <div className="text-center">
                                        <button
                                            onClick={() => setShowDropdown2(false)}
                                            className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90"
                                        >
                                            Apply Now
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <button className="flex items-center gap-1 px-4 py-5 text-sm text-orange-400 hover:underline">
                            <FiRotateCw className="text-sm" />
                            Reset Filter
                        </button>
                    </div>
                )}
            </div>

            {/* Tab Content */}
            <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
                <div className="min-w-[800px] md:min-w-0">
                    {selectedTab === "Uploaded by Drivers" && (
                        <table className="w-full table-auto text-sm text-left">
                            <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                                <tr>
                                    <th className="p-4">
                                        <input type="checkbox" />
                                    </th>
                                    <th className="p-4">Document title</th>
                                    <th className="p-4">Type</th>
                                    <th className="p-4">Container No</th>
                                    <th className="p-4">Uploaded by</th>
                                    <th className="p-4">Uploaded date & time</th>
                                    <th className="p-4">View</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dispatchData.map((row, idx) => (
                                    <tr key={idx} className="border-t border-[#2A2A4D]">
                                        <td className="p-4">
                                            <input type="checkbox" />
                                        </td>
                                        <td className="p-4">{row.id}</td>
                                        <td className="p-4">{row.order}</td>
                                        <td className="p-4">{row.origin}</td>
                                        <td className="p-4">{row.destination}</td>
                                        <td className="p-4">{row.type}</td>
                                        <td className="p-4">
                                            <button
                                                className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {selectedTab === "Uploaded by Admin" && (
                        <table className="w-full table-auto text-sm text-left">
                            <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                                <tr>
                                    <th className="p-4">
                                        <input type="checkbox" />
                                    </th>
                                    <th className="p-4">Document title</th>
                                    <th className="p-4">Type</th>
                                    <th className="p-4">Container No.</th>
                                    <th className="p-4">Uploaded By</th>
                                    <th className="p-4">Upload Date & Time</th>
                                    <th className="p-4">View</th>
                                </tr>
                            </thead>
                            <tbody>
                                {containerMovementData.map((row, idx) => (
                                    <tr key={idx} className="border-t border-[#2A2A4D]">
                                        <td className="p-4">
                                            <input type="checkbox" />
                                        </td>
                                        <td className="p-4">{row.id}</td>
                                        <td className="p-4">{row.movement}</td>
                                        <td className="p-4">{row.location}</td>
                                        <td className="p-4">{row.date}</td>
                                        <td className="p-4">{row.eta}</td>
                                        <td className="p-4">
                                            <button
                                                className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {selectedTab === "Pending Verification" && (
                        <table className="w-full table-auto text-sm text-left">
                            <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                                <tr>
                                    <th className="p-4">
                                        <input type="checkbox" />
                                    </th>
                                    <th className="p-4">Document title</th>
                                    <th className="p-4">Type</th>
                                    <th className="p-4">Container No</th>
                                    <th className="p-4">Uploaded by</th>
                                    <th className="p-4">Uploaded date & time</th>
                                    <th className="p-4">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subscriptionData.map((row, idx) => (
                                    <tr key={idx} className="border-t border-[#2A2A4D]">
                                        <td className="p-4">
                                            <input type="checkbox" />
                                        </td>
                                        <td className="p-4">{row.id}</td>
                                        <td className="p-4">{row.plan}</td>
                                        <td className="p-4">{row.startDate}</td>
                                        <td className="p-4">{row.endDate}</td>
                                        <td className="p-4">{row.status}</td>
                                        <td className="p-4">
                                            <button
                                                className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                                            >
                                                Download
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {selectedTab === "Access Roles" && (
                        <table className="w-full table-auto text-sm text-left">
                            <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                                <tr>
                                    <th className="p-4">
                                        <input type="checkbox" />
                                    </th>
                                    <th className="p-4">Role name</th>
                                    <th className="p-4">Permissions summary</th>
                                    <th className="p-4">Created by</th>
                                    <th className="p-4">Created date</th>
                                    <th className="p-4">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {routeOptimizationData.map((row, idx) => (
                                    <tr key={idx} className="border-t border-[#2A2A4D]">
                                        <td className="p-4">
                                            <input type="checkbox" />
                                        </td>
                                        <td className="p-4">{row.id}</td>
                                        <td className="p-4">{row.route}</td>
                                        <td className="p-4">{row.distance}</td>
                                        <td className="p-4">{row.time}</td>
                                        <td className="p-4">
                                            <button
                                                className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                                            >
                                                Download
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                <div className="text-sm text-gray-400 p-4">
                    Showing 1-{selectedTab === "Uploaded by Drivers" ? "07" : selectedTab === "Uploaded by Admin" ? "02" : selectedTab === "Pending Verification" ? "02" : "07"} of {selectedTab === "Uploaded by Drivers" ? "07" : selectedTab === "Uploaded by Admin" ? "02" : selectedTab === "Pending Verification" ? "02" : "07"}
                </div>
            </div>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 md:p-0">
                    <div
                        className="rounded-xl shadow-xl text-white p-4 md:p-6 relative w-full md:w-[90%] max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
                        style={{
                            background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
                        }}
                    >
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-2 right-4 text-2xl font-bold"
                        >
                            ×
                        </button>

                        <h2 className="text-xl font-bold mb-4">Custom Report Generator</h2>

                        <form className="space-y-4">
                            <div>
                                <label className="text-sm block mb-1">Report Type</label>
                                <select className="w-full px-3 py-2 rounded bg-white text-black">
                                    <option>Select Report Type</option>
                                    <option>Dispatch Summary</option>
                                    <option>Container Tracking Logs</option>
                                    <option>Driver-wise Performance</option>
                                    <option>Fuel Usage Summary</option>
                                    <option>Maintenance Logs</option>
                                    <option>Custom Time Report</option>
                                </select>
                            </div>
                            <div>
                                <label className="text-sm block mb-1">From Date</label>
                                <input
                                    className="w-full px-3 py-2 rounded bg-white text-black"
                                    placeholder="April 10, 2025"
                                />
                            </div>
                            <div>
                                <label className="text-sm block mb-1">To Date</label>
                                <input
                                    className="w-full px-3 py-2 rounded bg-white text-black"
                                    placeholder="April 10, 2025"
                                />
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4 max-w-md">
                                {toggleLabels.map((label, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white px-3 py-2 md:px-4 md:py-2 rounded shadow-md"
                                    >
                                        <button
                                            onClick={() => handleToggle(label)}
                                            className={`relative w-10 h-5 flex items-center rounded-full transition-colors duration-300 ${toggles[label] ? 'bg-green-500' : 'bg-gray-300'
                                                }`}
                                        >
                                            <span
                                                className={`absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300 ${toggles[label] ? 'translate-x-5' : ''
                                                    }`}
                                            ></span>
                                        </button>
                                        <span className="ml-3 text-sm text-black">{label}</span>
                                    </div>
                                ))}
                            </div>
                        </form>
                        <button
                            type="submit"
                            onClick={() => setShowModal(false)}
                            className="mt-6 w-full bg-[#792aff] text-white py-3 rounded-md font-semibold"
                        >
                            Generate Report
                        </button>
                    </div>
                </div>
            )}

            {isSuccessModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
                    <div className="bg-[#0F0D2E] p-6 md:p-8 rounded-2xl w-full max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
                        <h2 style={{ fontFamily: "Poppins" }} className="text-2xl md:text-[30px] font-bold text-white leading-tight">
                            Assigned <span className="text-3xl md:text-[45px] text-[#6F1AFF]">Successfully</span>
                        </h2>
                        <p className="text-sm text-gray-400 mb-6 mt-1">
                            Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.
                        </p>
                        <div className="flex justify-center mb-6">
                            <img src={check} alt="Checkmark" className="w-[150px] h-[120px] md:w-[197px] md:h-[156px]" />
                        </div>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                setIsSuccessModalOpen(false);
                            }}
                            className="w-full py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrdersContainers;